// Generated by Melange

import * as Buhta_platformapis__Buhta_idp_v1_profile from "./buhta_idp_v1_profile.js";
import * as Caml_module from "melange.js/caml_module.js";
import * as Curry from "melange.js/curry.js";
import * as Ocaml_protoc_plugin from "../../../vendored/ocaml_protoc_plugin/ocaml_protoc_plugin.js";
import * as Ocaml_protoc_plugin__Deserialize from "../../../vendored/ocaml_protoc_plugin/deserialize.js";
import * as Ocaml_protoc_plugin__Deserialize_json from "../../../vendored/ocaml_protoc_plugin/deserialize_json.js";
import * as Ocaml_protoc_plugin__Merge from "../../../vendored/ocaml_protoc_plugin/merge.js";
import * as Ocaml_protoc_plugin__Result from "../../../vendored/ocaml_protoc_plugin/result.js";
import * as Ocaml_protoc_plugin__Serialize from "../../../vendored/ocaml_protoc_plugin/serialize.js";
import * as Ocaml_protoc_plugin__Serialize_json from "../../../vendored/ocaml_protoc_plugin/serialize_json.js";
import * as Ocaml_protoc_plugin__Spec from "../../../vendored/ocaml_protoc_plugin/spec.js";
import * as Ocaml_protoc_plugin__Writer from "../../../vendored/ocaml_protoc_plugin/writer.js";

const Imported$pmodules = {};

const GetProfileRequest = Caml_module.init_mod([
      "proto/platformapis/gen/buhta_idp_v1_profile_service.ml",
      294,
      12
    ], {
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    });

const GetProfileResponse = Caml_module.init_mod([
      "proto/platformapis/gen/buhta_idp_v1_profile_service.ml",
      354,
      12
    ], {
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    });

function name(param) {
  return ".buhta.idp.v1.GetProfileRequest";
}

function make(expandOpt, param) {
  const expand = expandOpt !== undefined ? expandOpt : /* [] */0;
  return {
          expand: expand
        };
}

const merge_expand = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.repeated([
          [
            2,
            "expand",
            "expand"
          ],
          Ocaml_protoc_plugin__Spec.string,
          Ocaml_protoc_plugin__Spec.not_packed
        ]));

function merge(t1, t2) {
  return {
          expand: Curry._2(merge_expand, t1.expand, t2.expand)
        };
}

function spec(param) {
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.repeated([
                  [
                    2,
                    "expand",
                    "expand"
                  ],
                  Ocaml_protoc_plugin__Spec.string,
                  Ocaml_protoc_plugin__Spec.not_packed
                ]), Ocaml_protoc_plugin__Spec.nil);
}

const serialize = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Serialize.serialize(spec(undefined));
    });

function to_proto$p(writer, param) {
  Curry._2(serialize, writer, param.expand);
}

function to_proto(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p(writer, t);
  return writer;
}

function constructor(expand) {
  return {
          expand: expand
        };
}

const from_proto_exn = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize.deserialize(spec(undefined), constructor);
    });

function from_proto(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_proto_exn, writer);
            });
}

function to_json(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.idp.v1.GetProfileRequest", spec(undefined))(options);
  return function (param) {
    return Curry._1(serialize, param.expand);
  };
}

function constructor$1(expand) {
  return {
          expand: expand
        };
}

const from_json_exn = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.idp.v1.GetProfileRequest", spec(undefined), constructor$1);
    });

function from_json(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_json_exn, json);
            });
}

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    }, GetProfileRequest, {
      make: make,
      to_proto: to_proto,
      from_proto: from_proto,
      to_json: to_json,
      from_json: from_json,
      name: name,
      merge: merge,
      to_proto$p: to_proto$p,
      from_proto_exn: from_proto_exn,
      from_json_exn: from_json_exn
    });

function name$1(param) {
  return ".buhta.idp.v1.GetProfileResponse";
}

function make$1(profile, param) {
  return {
          profile: profile
        };
}

const $$let = Buhta_platformapis__Buhta_idp_v1_profile.Buhta.Idp.V1.Profile;

const merge_profile = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
          [
            1,
            "profile",
            "profile"
          ],
          Ocaml_protoc_plugin__Spec.message({
                name: $$let.name,
                make: $$let.make,
                from_proto: $$let.from_proto,
                from_proto_exn: $$let.from_proto_exn,
                to_proto: $$let.to_proto,
                to_proto$p: $$let.to_proto$p,
                merge: $$let.merge,
                to_json: $$let.to_json,
                from_json_exn: $$let.from_json_exn,
                from_json: $$let.from_json
              })
        ]));

function merge$1(t1, t2) {
  return {
          profile: Curry._2(merge_profile, t1.profile, t2.profile)
        };
}

function spec$1(param) {
  const $$let = Buhta_platformapis__Buhta_idp_v1_profile.Buhta.Idp.V1.Profile;
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
                  [
                    1,
                    "profile",
                    "profile"
                  ],
                  Ocaml_protoc_plugin__Spec.message({
                        name: $$let.name,
                        make: $$let.make,
                        from_proto: $$let.from_proto,
                        from_proto_exn: $$let.from_proto_exn,
                        to_proto: $$let.to_proto,
                        to_proto$p: $$let.to_proto$p,
                        merge: $$let.merge,
                        to_json: $$let.to_json,
                        from_json_exn: $$let.from_json_exn,
                        from_json: $$let.from_json
                      })
                ]), Ocaml_protoc_plugin__Spec.nil);
}

const serialize$1 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Serialize.serialize(spec$1(undefined));
    });

function to_proto$p$1(writer, param) {
  Curry._2(serialize$1, writer, param.profile);
}

function to_proto$1(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$1(writer, t);
  return writer;
}

function constructor$2(profile) {
  return {
          profile: profile
        };
}

const from_proto_exn$1 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize.deserialize(spec$1(undefined), constructor$2);
    });

function from_proto$1(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_proto_exn$1, writer);
            });
}

function to_json$1(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.idp.v1.GetProfileResponse", spec$1(undefined))(options);
  return function (param) {
    return Curry._1(serialize, param.profile);
  };
}

function constructor$3(profile) {
  return {
          profile: profile
        };
}

const from_json_exn$1 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.idp.v1.GetProfileResponse", spec$1(undefined), constructor$3);
    });

function from_json$1(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_json_exn$1, json);
            });
}

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    }, GetProfileResponse, {
      make: make$1,
      to_proto: to_proto$1,
      from_proto: from_proto$1,
      to_json: to_json$1,
      from_json: from_json$1,
      name: name$1,
      merge: merge$1,
      to_proto$p: to_proto$p$1,
      from_proto_exn: from_proto_exn$1,
      from_json_exn: from_json_exn$1
    });

const getProfile_0 = {
  name: GetProfileRequest.name,
  make: GetProfileRequest.make,
  from_proto: GetProfileRequest.from_proto,
  from_proto_exn: GetProfileRequest.from_proto_exn,
  to_proto: GetProfileRequest.to_proto,
  to_proto$p: GetProfileRequest.to_proto$p,
  merge: GetProfileRequest.merge,
  to_json: GetProfileRequest.to_json,
  from_json_exn: GetProfileRequest.from_json_exn,
  from_json: GetProfileRequest.from_json
};

const getProfile_1 = {
  name: GetProfileResponse.name,
  make: GetProfileResponse.make,
  from_proto: GetProfileResponse.from_proto,
  from_proto_exn: GetProfileResponse.from_proto_exn,
  to_proto: GetProfileResponse.to_proto,
  to_proto$p: GetProfileResponse.to_proto$p,
  merge: GetProfileResponse.merge,
  to_json: GetProfileResponse.to_json,
  from_json_exn: GetProfileResponse.from_json_exn,
  from_json: GetProfileResponse.from_json
};

const getProfile = [
  getProfile_0,
  getProfile_1
];

const V1_ProfileService = {
  GetProfile: {
    name: "/buhta.idp.v1.ProfileService/GetProfile",
    package_name: "buhta.idp.v1",
    service_name: "ProfileService",
    method_name: "GetProfile",
    $$Request: {
      name: GetProfileRequest.name,
      make: GetProfileRequest.make,
      from_proto: GetProfileRequest.from_proto,
      from_proto_exn: GetProfileRequest.from_proto_exn,
      to_proto: GetProfileRequest.to_proto,
      to_proto$p: GetProfileRequest.to_proto$p,
      merge: GetProfileRequest.merge,
      to_json: GetProfileRequest.to_json,
      from_json_exn: GetProfileRequest.from_json_exn,
      from_json: GetProfileRequest.from_json
    },
    $$Response: {
      name: GetProfileResponse.name,
      make: GetProfileResponse.make,
      from_proto: GetProfileResponse.from_proto,
      from_proto_exn: GetProfileResponse.from_proto_exn,
      to_proto: GetProfileResponse.to_proto,
      to_proto$p: GetProfileResponse.to_proto$p,
      merge: GetProfileResponse.merge,
      to_json: GetProfileResponse.to_json,
      from_json_exn: GetProfileResponse.from_json_exn,
      from_json: GetProfileResponse.from_json
    }
  },
  getProfile: getProfile
};

const V1 = {
  GetProfileRequest: GetProfileRequest,
  GetProfileResponse: GetProfileResponse,
  ProfileService: V1_ProfileService
};

const Idp = {
  V1: V1
};

const Buhta = {
  Idp: Idp
};

export {
  Imported$pmodules ,
  Buhta ,
}
/* GetProfileRequest Not a pure module */
